module.exports = __webpack_public_path__ + "01.png?db2366ffd940e5dab8008e7627cde639";


//////////////////
// WEBPACK FOOTER
// ./src/assets/screenshots/01.png
// module id = 115
// module chunks = 3